(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-annc]').forEach((bar) => {
    const slides = [...bar.querySelectorAll('.ax-annc__slide')];
    if (slides.length <= 1) return;

    const autorotate = bar.dataset.autorotate === 'true';
    const interval = parseInt(bar.dataset.interval, 10) || 5000;
    let i = 0;
    let timer = null;

    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
    };
    const reset = () => {
      clearInterval(timer);
      if (autorotate) timer = setInterval(() => go(i + 1), interval);
    };

    const next = bar.querySelector('[data-annc-next]');
    const prev = bar.querySelector('[data-annc-prev]');
    if (next) next.addEventListener('click', () => { go(i + 1); reset(); });
    if (prev) prev.addEventListener('click', () => { go(i - 1); reset(); });
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', reset);
    reset();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const form = document.getElementById('FacetFilterForm');
    if (!form) return;

    const submit = () => form.submit();
    const isDrawer = () => window.matchMedia('(max-width: 900px)').matches;

    // Inputs inside the form (checkboxes, price) bubble their change to the form.
    // On mobile the facets live in a drawer: batch changes and apply on demand
    // (via "Voir les résultats") instead of reloading on every tap.
    form.addEventListener('change', (e) => {
      if (isDrawer() && e.target.closest('[data-facets-drawer]')) return;
      submit();
    });

    // The sort <select> is associated via the `form` attribute but lives outside
    // the form's DOM subtree, so its change must be wired up explicitly. It is not
    // in the drawer, so it always submits immediately.
    document.querySelectorAll('[form="FacetFilterForm"]').forEach((el) => {
      if (el.closest('#FacetFilterForm')) return;
      el.addEventListener('change', submit);
    });
  })();

  /* ── Mobile / tablet facets drawer ── */
  (function () {
    const drawer = document.querySelector('[data-facets-drawer]');
    const overlay = document.querySelector('[data-facets-overlay]');
    if (!drawer || !overlay) return;
    const openBtn = document.querySelector('[data-facets-open]');

    const open = () => {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    };

    if (openBtn) openBtn.addEventListener('click', open);
    overlay.addEventListener('click', close);
    document.querySelectorAll('[data-facets-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    const applyBtn = drawer.querySelector('[data-facets-apply]');
    if (applyBtn) applyBtn.addEventListener('click', () => {
      const f = document.getElementById('FacetFilterForm');
      if (f) f.submit();
    });
  })();

  // Persist which facet panels are open across the filter reloads.
  (function () {
    const KEY = 'ax-facets-state';
    const read = () => {
      try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
    };
    const write = (s) => {
      try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    };

    document.querySelectorAll('details.ax-facet[data-facet-key]').forEach((d) => {
      const stateKey = 'facet:' + d.dataset.facetKey;
      const saved = read();
      if (stateKey in saved) d.open = saved[stateKey];
      d.addEventListener('toggle', () => {
        const s = read();
        s[stateKey] = d.open;
        write(s);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const vp = hero.querySelector('[data-hero-vp]');
    const slides = [...vp.querySelectorAll('.ax-hero__slide')];
    if (slides.length <= 1) return;

    const dotsWrap = hero.querySelector('[data-hero-dots]');
    const cur = hero.querySelector('[data-hero-cur]');
    const autoplay = hero.dataset.autoplay === 'true';
    const interval = parseInt(hero.dataset.interval, 10) || 6000;
    let i = 0;
    let timer = null;

    const dots = slides.map((_, k) => {
      const b = document.createElement('button');
      b.type = 'button';
      if (k === 0) b.classList.add('is-on');
      b.addEventListener('click', () => { go(k); reset(); });
      dotsWrap.appendChild(b);
      return b;
    });

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      if (cur) cur.textContent = String(i + 1);
    }
    function next() { go(i + 1); }
    function reset() {
      clearInterval(timer);
      if (autoplay) timer = setInterval(next, interval);
    }

    hero.querySelector('[data-hero-next]').addEventListener('click', () => { next(); reset(); });
    hero.querySelector('[data-hero-prev]').addEventListener('click', () => { go(i - 1); reset(); });
    vp.addEventListener('mouseenter', () => clearInterval(timer));
    vp.addEventListener('mouseleave', reset);
    reset();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-agenda"]) return;
  try {
    
  document.querySelectorAll('.ax-ag').forEach((root) => {
    const source = root.querySelector('[data-ag-source]');
    const view = root.querySelector('[data-ag-view]');
    const empty = root.querySelector('[data-ag-empty]');
    if (!source || !view) return;

    const rows = [...source.querySelectorAll('.ax-evrow')];
    let genre = 'all';
    let time = 'upcoming';

    function render() {
      const filtered = rows.filter((r) => {
        const okGenre = genre === 'all' || r.dataset.genre === genre;
        const okTime = time === 'upcoming' ? r.dataset.past === 'false' : r.dataset.past === 'true';
        return okGenre && okTime;
      });
      filtered.sort((a, b) => {
        const d = Number(a.dataset.ts) - Number(b.dataset.ts);
        return time === 'past' ? -d : d;
      });

      view.innerHTML = '';
      let currentMonth = null;

      filtered.forEach((r) => {
        if (r.dataset.month !== currentMonth) {
          currentMonth = r.dataset.month;
          const head = document.createElement('div');
          head.className = 'ax-ag__month';
          head.textContent = r.dataset.monthLabel;
          view.appendChild(head);
        }
        view.appendChild(r);
      });

      empty.hidden = filtered.length > 0;
    }

    root.querySelectorAll('[data-genre]').forEach((btn) => {
      btn.addEventListener('click', () => {
        genre = btn.dataset.genre;
        root.querySelectorAll('[data-genre]').forEach((b) => b.classList.toggle('is-on', b === btn));
        render();
      });
    });
    root.querySelectorAll('[data-time]').forEach((btn) => {
      btn.addEventListener('click', () => {
        time = btn.dataset.time;
        root.querySelectorAll('[data-time]').forEach((b) => b.classList.toggle('is-on', b === btn));
        render();
      });
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-generic"]) return;
  try {
    
  document.querySelectorAll('.ax-pg__media').forEach((media) => {
    const stage = media.querySelector('.ax-pg__stage img');
    const thumbs = media.querySelectorAll('.ax-pg__thumb');
    if (!stage || thumbs.length === 0) return;
    media.addEventListener('click', (evt) => {
      const thumb = evt.target.closest('.ax-pg__thumb');
      if (!thumb || !thumb.dataset.full) return;
      stage.removeAttribute('srcset');
      stage.src = thumb.dataset.full;
      if (thumb.dataset.alt) stage.alt = thumb.dataset.alt;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rail-row]').forEach((row) => {
    const ctrls = row.closest('.ax-rail__inner').querySelector('[data-rail-ctrls]');
    if (!ctrls) return;
    const prev = ctrls.querySelector('[data-dir="prev"]');
    const next = ctrls.querySelector('[data-dir="next"]');

    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 1;
      ctrls.hidden = max <= 0;
      if (prev) prev.disabled = row.scrollLeft <= 0;
      if (next) next.disabled = row.scrollLeft >= max;
    };

    ctrls.addEventListener('click', (evt) => {
      const btn = evt.target.closest('button[data-dir]');
      if (!btn) return;
      const delta = btn.dataset.dir === 'next' ? row.clientWidth : -row.clientWidth;
      row.scrollBy({ left: delta, behavior: 'smooth' });
    });

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.ax-product__media').forEach((media) => {
    const stage = media.querySelector('.ax-product__cover-stage img');
    const thumbs = media.querySelectorAll('.ax-product__thumb');
    if (!stage || thumbs.length === 0) return;
    media.addEventListener('click', (evt) => {
      const thumb = evt.target.closest('.ax-product__thumb');
      if (!thumb || !thumb.dataset.full) return;
      stage.removeAttribute('srcset');
      stage.src = thumb.dataset.full;
      if (thumb.dataset.alt) stage.alt = thumb.dataset.alt;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  function axRailCarousel(row, ctrls) {
    if (!ctrls) return;
    const prev = ctrls.querySelector('[data-dir="prev"]');
    const next = ctrls.querySelector('[data-dir="next"]');
    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 1;
      ctrls.hidden = max <= 0;
      if (prev) prev.disabled = row.scrollLeft <= 0;
      if (next) next.disabled = row.scrollLeft >= max;
    };
    ctrls.addEventListener('click', (evt) => {
      const btn = evt.target.closest('button[data-dir]');
      if (!btn) return;
      const delta = btn.dataset.dir === 'next' ? row.clientWidth : -row.clientWidth;
      row.scrollBy({ left: delta, behavior: 'smooth' });
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function axInitRail(root) {
    const row = root.querySelector('[data-related-row]');
    const ctrls = root.querySelector('[data-related-ctrls]');
    const loading = root.querySelector('[data-related-loading]');
    const cfgEl = root.querySelector('[data-rail-filters]');

    const stopLoading = () => { if (loading) loading.remove(); };
    const showEmpty = () => { root.hidden = true; };

    let filters = [];
    try { filters = JSON.parse(cfgEl.textContent); } catch (e) { filters = []; }
    if (!filters.length) { showEmpty(); return; }

    const params = new URLSearchParams();
    params.set('section_id', 'collection-rail-cards');
    params.set('sort_by', root.dataset.sort || 'created-descending');
    filters.forEach((f) => { if (f && f.k && f.v) params.append(f.k, f.v); });

    fetch('/collections/all?' + params.toString())
      .then((res) => { if (!res.ok) throw new Error('rail fetch failed'); return res.text(); })
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const current = root.dataset.currentHandle || '';
        const limit = parseInt(root.dataset.limit, 10) || 12;
        let cards = Array.from(parsed.querySelectorAll('[data-product-card]'));
        cards = cards.filter((c) => (c.dataset.productHandle || '') !== current);
        cards = cards.slice(0, limit);
        if (!cards.length) { showEmpty(); return; }
        cards.forEach((c) => row.appendChild(c));
        stopLoading();
        row.hidden = false;
        axRailCarousel(row, ctrls);
      })
      .catch(() => { showEmpty(); });
  }

  document.querySelectorAll('[data-rail]').forEach(axInitRail);

  } catch(e) { console.error(e); }
})();
})();
